export function lowercaseKeys (obj) {
  const newObj = {}
  Object.keys(obj).forEach(key => {
    newObj[key.toLowerCase()] = obj[key]
  })
  return newObj
}
